import React from "react";
import "../estimate/estimateWorkspace.css";
import { formatMeasurementArea, formatMeasurementDimensions } from "../../helpers/measurementModel";
import { WorkspaceOverflowMenu } from "./WorkspaceOverflowMenu";

export function WorkspaceClientLine({ label = "Client", value }) {
  return (
    <div className="est-home-client-row">
      <div className="est-home-field-label">{label}</div>
      <div className="est-home-client-value">{value || "—"}</div>
    </div>
  );
}

export function WorkspaceStatusRow({ identifier, status }) {
  return (
    <div className="est-page-subtitle-row">
      {identifier ? <span>{identifier}</span> : null}
      {status ? <span className="est-status-pill">{status}</span> : null}
    </div>
  );
}

export function WorkspaceTextButton({ children, onClick }) {
  return (
    <button type="button" className="est-home-edit-toggle" onClick={onClick}>
      {children}
    </button>
  );
}

export function WorkspaceSummaryRow({ label, value, emphasis = false }) {
  return (
    <div className={"est-total-row" + (emphasis ? " est-total-row--emphasis" : "")}>
      <span className="est-total-row-label">{label}</span>
      <span className="est-total-row-value">{value}</span>
    </div>
  );
}

export function WorkspaceSummaryLink({ label, value, onClick }) {
  return (
    <button type="button" className="est-total-row est-total-row--link" onClick={onClick}>
      <span className="est-total-row-label">{label}</span>
      <span className="est-total-row-value est-total-row-value--with-chevron">
        {value}
        <span className="est-total-row-chevron" aria-hidden="true">
          ›
        </span>
      </span>
    </button>
  );
}

export function WorkspaceEmpty({ children }) {
  return <div className="est-home-empty-row">{children}</div>;
}

export function WorkspaceAddButton({ children, onClick, first = false }) {
  return (
    <button
      type="button"
      className={first ? "est-add-first-btn" : "est-add-row-btn"}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export function WorkspaceHeaderMeta({ children, menuItems, menuLabel }) {
  return (
    <div className="est-workspace-header-row">
      <div className="est-workspace-header-text est-page-subtitle-row">{children}</div>
      <WorkspaceOverflowMenu items={menuItems} ariaLabel={menuLabel} />
    </div>
  );
}

/**
 * Measurement rows shared by Estimate and Project feature workspaces.
 * Tap edits. The overflow menu deletes. No photo control.
 */
export function WorkspaceMeasurementSection({
  sections,
  summary,
  editable,
  onAdd,
  onEdit,
  onDelete,
}) {
  return (
    <div className="est-section-block">
      <div className="est-section-summary-row">
        <span className="est-section-summary-label">Measurements</span>
        {summary ? <span className="est-section-summary-value">{summary}</span> : null}
      </div>

      {sections.length === 0 ? (
        <WorkspaceEmpty>No measurements yet.</WorkspaceEmpty>
      ) : (
        sections.map((section) => (
          <div
            key={section.section_id}
            className="est-row"
            role={editable ? "button" : undefined}
            tabIndex={editable ? 0 : undefined}
            onClick={() => editable && onEdit?.(section)}
          >
            <div className="est-row-main">
              <div className="est-row-title">{section.name}</div>
              <div className="est-row-meta">
                {formatMeasurementDimensions(section)}
              </div>
            </div>
            <div className="est-row-value">{formatMeasurementArea(section)}</div>
            {editable && (
              <WorkspaceOverflowMenu
                ariaLabel="Measurement actions"
                items={[
                  {
                    label: "Delete",
                    onClick: () => onDelete?.(section),
                    destructive: true,
                  },
                ]}
              />
            )}
          </div>
        ))
      )}

      {editable && (
        <WorkspaceAddButton onClick={onAdd}>+ Add Measurement</WorkspaceAddButton>
      )}
    </div>
  );
}
